import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Trust from './components/Trust';
import Industries from './components/Industries';
import ValueProposition from './components/ValueProposition';
import Approach from './components/Approach';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white dark:bg-[#0a1520] transition-colors duration-300">
      <Hero />
      <Trust />
      <Industries />
      <ValueProposition />
      <Approach />
      <CTA />
      <Footer />
    </div>
  );
}